export default __webpack_public_path__ + "static/media/video.441244d1.svg";